<template>
  <div class="popup__newsletter-wrapper">
    <SmoothReflow>
      <div
        v-if="requestState == REQUEST_STATES.success"
        class="popup__request-msg popup__request-msg--success"
        v-html="success"
      ></div>
    </SmoothReflow>
    <SmoothReflow>
      <div
        v-if="errorMessage || requestState == REQUEST_STATES.error"
        :class="errorMessageClasses"
        v-html="errorMessage || error"
      ></div>
    </SmoothReflow>
    <SmoothReflow>
      <div v-if="requestState != REQUEST_STATES.success" class="popup__newsletter-form">
        <div class="popup__input-wrap">
          <input
            v-model="email"
            class="popup__input"
            :placeholder="inputPlaceholder"
            @keyup="handleEmailInputChange"
          />
        </div>
        <div class="popup__cta-wrap">
          <span
            class="cta cta--button cta--light"
            @click.prevent="submitNewsletterSignupForm({ source: 'popup' })"
          >
            {{ $t('newsletter.sign_up') }}
          </span>
        </div>
      </div>
    </SmoothReflow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import newsletterSignupFormMixin from '@/mixins/newsletter-signup-form'
import SmoothReflow from '@/components/_shared/SmoothReflow.vue'

export default {
  name: 'PopupNewsletterForm',
  components: {
    SmoothReflow,
  },
  mixins: [newsletterSignupFormMixin],

  data() {
    return {
      selectedGender: '',
    }
  },

  computed: {
    ...mapGetters({
      variant: 'popup/variant',
      theme: 'popup/theme',
      success: 'popup/success',
      error: 'popup/error',
      inputPlaceholder: 'popup/inputPlaceholder',
      closeOverlay: 'popup/closeOverlay',
    }),

    errorMessageClasses() {
      return [
        'popup__request-msg',
        'popup__request-msg--error',
        { 'popup__request-msg--transparent': this.hideErrorMessage },
      ]
    },
  },

  methods: {
    handleEmailInputChange() {
      if (this.submitAttempt > 0) {
        this.errorMessage = On.helpers.validateEmail(this.email)
          ? null
          : this.$t('errors.invalid_email')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$half-gutter: $site-gutter / 2;
$input-width: 30vw;
$input-height: 50px;
$input-height-medium: 46px;

.popup {
  &__newsletter-wrapper {
    margin-top: $half-gutter;
  }

  &__request-msg,
  &__newsletter-form {
    overflow: hidden;
    transition: height $transition-time-slow;
  }

  &__request-msg {
    overflow: hidden;
    padding: $half-gutter 0;
    font-size: $font-size-larger;
    font-family: $font-family-headings;
    letter-spacing: $font-spacing-neutraface;
    transition: height $transition-time-slow;

    &--success {
      color: $color-green;
    }

    &--error {
      color: $color-red;
    }

    &--transparent {
      opacity: 0;
    }
  }

  &__input-wrap {
    padding: 20px 0 10px;
  }

  &__gender-wrap {
    padding: 0 0 10px;
  }

  &__input {
    $line-height: round($font-size-normal * 1.2);
    $padding-vert-medium: ($input-height-medium - $line-height - 2) / 2;
    $padding-vert: ($input-height - $line-height - 2) / 2;
    background: transparent;
    color: $color-white;
    border: 1px solid $color-white;
    padding-top: ceil($padding-vert-medium) + 1;
    padding-right: $site-gutter;
    padding-bottom: floor($padding-vert-medium) - 1;
    padding-left: 16px;
    width: 100%;
    max-width: 420px;
    line-height: $line-height;
    font-size: $font-size-normal;
    vertical-align: top;

    &::placeholder {
      color: $color-white;
      font-family: $font-family-body;
      font-style: normal;
    }

    @include min-screen($mq-width-large) {
      padding-top: ceil($padding-vert) + 1;
      padding-bottom: floor($padding-vert) - 1;
    }

    @media ($mq-medium) and ($mq-height-small) {
      .newsletter-subscribe-overlay--bottom & {
        margin: 0;
        min-width: 250px;
        width: $input-width;

        @include min-screen($mq-width-high) {
          width: $mq-width-high * ($input-width / 100vw);
        }
      }
    }
  }

  .cta:after {
      border-bottom: none;
  }

  .cta--button {
    margin: 0 auto;
    max-width: 420px;
  }

  .cta--light {
    $cta-padding-vert-medium: ($input-height-medium - $font-size-normal) / 2;
    $cta-padding-vert: ($input-height - $font-size-normal) / 2;
    background: $color-grey-light-3;
    padding-top: $cta-padding-vert-medium;
    padding-bottom: $cta-padding-vert-medium;
    color: $color-grey-dark-2;
    font-size: $font-size-normal;
    line-height: 1;

    @include min-screen($mq-width-large) {
      padding-top: ceil($cta-padding-vert) + 1;
      padding-bottom: floor($cta-padding-vert) - 1;
    }

    &:hover {
      background: $color-grey-light-1;
    }
  }
}
</style>
